import type { PContainer, PGraphics } from '../../../engine/aliases'
import { l } from '../../../lib/imports'
import { mathUtils } from '../../../lib/mathUtils-sidecar'
import type { IStevieText2 } from '../../../uiParts/stevieTexts2'
import { stevieTexts2 } from '../../../uiParts/stevieTexts2-sidecar'
import { chessFonts } from './chessFonts-sidecar'
import type { IChessUiGButton } from './chessUiGButtons'
import { chessUiGButtons } from './chessUiGButtons-sidecar'

export interface IChessUiGSelector {
  x: number
  y: number
  w: number
  h: number
  labelW: number
  text: string
  values: string[]
  value: string
  idx: number
  isVisible: boolean
  isEnabled: boolean
  buttons: IChessUiGButton[]
  onChange: () => void
}

let buttonWidth = 20
let buttonHeight = 30
let buttonSpacing = 0
let buttonFeather = 10
export const create = (
  text: string,
  values: string[],
  x = 0,
  y = 0,
  w = 300,
  labelW = 140,
) => {
  let b: IChessUiGSelector = {
    text,
    values,
    value: values[0],
    idx: 0,
    x: x,
    y: y,
    w: w,
    h: 40,
    labelW,
    buttons: [],
    isVisible: true,
    onChange: () => {},
    isEnabled: true,
  }

  let b1 = chessUiGButtons.create('', x + labelW, y, () => {
    setSelected(b, b.idx - 1)
    b.onChange()
  })
  b1.w = buttonWidth
  b1.h = buttonHeight
  b1.feather = buttonFeather
  b1.renderer = chessUiGButtons.renderArrowLeft
  let b2 = chessUiGButtons.create('', x + w - buttonWidth, y, () => {
    setSelected(b, b.idx + 1)
    b.onChange()
  })
  b2.w = buttonWidth
  b2.h = buttonHeight
  b2.feather = buttonFeather
  b2.renderer = chessUiGButtons.renderArrowRight
  b.buttons.push(b1)
  b.buttons.push(b2)

  return b
}

export const setValue = (obj: IChessUiGSelector, v: string) => {
  let idx = l.findIndex(obj.values, (c) => c === v)
  if (idx !== -1) {
    setSelected(obj, idx)
  }
}

export const hitTest = (
  objs: IChessUiGSelector[],
  x: number,
  y: number,
  official: boolean,
) => {
  let over: IChessUiGSelector | null = null
  for (let i = 0; i < objs.length; i++) {
    let c = objs[i]
    if (!c.isVisible) {
      continue
    }
    if (chessUiGButtons.hitTest(c.buttons, x, y, official)) {
      over = c
    }
  }

  return over !== null
}

export const render = (
  g: PGraphics,
  objs: IChessUiGSelector[],
  texts: IStevieText2[],
  layer: PContainer,
) => {
  for (let i = 0; i < objs.length; i++) {
    let c = objs[i]
    if (!c.isVisible) {
      continue
    }

    // console.log('rendered gselector')

    c.buttons[0].x = c.x + c.labelW
    c.buttons[0].y = c.y
    c.buttons[1].x = c.x + c.w - c.buttons[1].w
    c.buttons[1].y = c.y
    if (c.isEnabled) {
      chessUiGButtons.render(g, c.buttons, texts, layer)
    }

    let _label = stevieTexts2.create(
      chessFonts.get().f,
      c.x + 16,
      c.y + 14, //18,
      layer,
    )
    stevieTexts2.setText(_label, c.text)
    stevieTexts2.setScale(_label, 0.4)
    texts.push(_label)

    let _text = stevieTexts2.create(
      chessFonts.get().f,
      c.x + 16 + buttonWidth + buttonSpacing + c.labelW,
      c.y + 14, //18,
      layer,
    )
    stevieTexts2.setText(_text, c.value)
    stevieTexts2.setScale(_text, 0.4)
    texts.push(_text)
  }
}

export function setSelected(obj: IChessUiGSelector, idx: number) {
  obj.idx = mathUtils.betterMod(idx, obj.values.length)
  obj.value = obj.values[obj.idx]
}
export function setEnabled(obj: IChessUiGSelector, enabled: boolean) {
  obj.isEnabled = enabled
}
